import ProjectSelector from './src/main';

/* istanbul ignore next */
ProjectSelector.install = function(Vue) {
  Vue.component(ProjectSelector.name, ProjectSelector);
};

export default ProjectSelector;
